module.exports = __webpack_public_path__ + "img/elevatedEvent.7ad969d5.svg";